// ############################ Require packages here ############################
import React, { Fragment, useState, useRef } from 'react'
import { Modal, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { Helmet } from 'react-helmet';
import Select from 'react-select';
import {
    loadCaptchaEnginge,
    LoadCanvasTemplate,
    validateCaptcha,
} from "react-simple-captcha";

// ############################ Require files here ###############################

import { submitContactus, submitThreatAdvisory } from '../../Redux/ActionCreators/contactusAction';


export default function ContactThreatAdvisory() {
    const [loading, setLoading] = useState(false);
    const [captchaError, setCaptchaError] = useState('');
    const [isConfirm, setIsConfirm] = useState(false);
    const [data, setData] = useState(null);
    const initialValues = {
        fname: '', lname: '', email: '', organization: "", job: "", message: ""
    };

    const formikRef = useRef();
    const dispatch = useDispatch();

    const validationSchema =
        Yup.object({
            fname: Yup.string()
                .trim('Only alphanumricals allowed')
                .strict(true)
                .matches(/^[a-zA-Z0-9\s]+$/, 'First Name should only contain alphabets, numbers, and spaces')
                .required('First Name is required'),
            lname: Yup.string()
                .trim('Only alphanumricals allowed')
                .strict(true)
                .matches(/^[a-zA-Z0-9\s]+$/, 'Last Name should only contain alphabets, numbers, and spaces')
                .required('Last Name is required'),
            email: Yup.string()
                .trim('No extra space allowed')
                .strict(true)
                .required('Email is required')
                .matches(/^([\w.-]+)@(?!hotmail\.com|gmail\.com|googlemail\.com|yahoo\.com|gmx\.com|ymail\.com|outlook\.com|bluewin\.ch|protonmail\.com|t-online\.de|web\.de|online\.de|aol\.com|live\.com)([a-zA-Z\d-]+\.)+([a-zA-Z]{2,63})$/, 'Enter Only Business email address'),
            organization: Yup.string()
                .trim('No extra space allowed')
                .strict(true)
                .matches(/^[a-zA-Z0-9\s]+$/, 'Organization should only contain alphabets, numbers, and spaces')
                .required('Organization is required'),
            message: Yup.string()
                .trim('Only alphanumricals allowed')
                .strict(true)
                .max(1500, "Maximum 1500 characters allowed")
                .matches(/^[a-zA-Z0-9\s]+$/, 'Message should only contain alphabets, numbers, and spaces')
                .notRequired(''),
        });


    const handleSubmit = async (values, { setSubmitting }) => {
        let obj = {
            "fname": values?.fname,
            "lname": values?.lname,
            "email": values?.email,
            "phone": values?.phone,
            "organization": values?.organization,
            "job": values?.job,
            "message": values?.message
        }
        setData(obj);
        setIsConfirm(true);
        setSubmitting(false);
        setTimeout(() => {
            loadCaptchaEnginge(6);
        }, 500);
    }
    const handleCaptchaSubmit = async () => {
        // < ! --let's assume there is an HTML input text box with id 'user_captcha_input' to get user input -->    
        let user_captcha_value = document.getElementById('user_captcha_input').value;
        await setLoading(true);
        if (validateCaptcha(user_captcha_value, false) === true) {
            setCaptchaError('');
            const res = await dispatch(submitThreatAdvisory(data));
            if (res?.type === 'THREAT_ADVISORY_SUBMIT') {
                if (formikRef.current) {
                    formikRef.current.resetForm();;
                    setIsConfirm(false);
                }
            }
        }
        else {
            setCaptchaError('Captcha Does Not Match');
        }
        setTimeout(() => {
            setLoading(false)
        }, 1000);
    }

    const customStyles = {
        menu: (provided, state) => ({
            ...provided,
            backgroundColor: '#040c30',
            zIndex: 3
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? 'lightblue' : '#040c30', // Change background color on selection
            color: '#b6bcbf', // Ensure text is visible
            ':hover': {
                color: '#000',
                backgroundColor: '#b6bcbf' // Change background color on hover
            }
        })
    };

    return (
        <div className='seq-contact-us'>
            <div className='reverse-grad'>
            </div>
            {/* section 0 PAGE HEADING */}
            <Helmet>
                <title>Sequretek | Contact us </title>
                <meta http-equiv="X-Frame-Options" content="DENY" />
                <meta name="description" content="Get in touch with Sequretek for top-notch cybersecurity products & solutions and real-time protection." />
                <meta property="og:title" content="Sequretek | Contact us " />
                <meta property="og:description" content="Get in touch with Sequretek for top-notch cybersecurity products & solutions and real-time protection." />
            </Helmet>
            {/* section 1 CONTACT FORM */}
            <div className='container'>
                <div className='row justify-content-center me-0'>
                    <div className='col-md-10 col-sm-12 col-12'>
                        <div className='contact-tabs'>

                        </div>
                        <div className='breach-container mt-4'>
                            <div className='row me-0 seq-form'>
                                <div className="col-lg-4 col-sm-12 left-section" style={{ backgroundImage: window.innerWidth > 767 ? `linear-gradient(180deg, #0e49b5 0.24%, rgba(0, 0, 0, 0) 100%),url("/images/bg_thread_adv.png")` : `url("/images/bg_thread_adv.png"})` }}>
                                    <div className='left-section-text'>
                                        <img className='justify-content-start' src='/images/lightbulb-on.svg' alt='' />
                                        <h2>Are You Prepared for Emerging Cyberthreats?</h2>
                                    </div>
                                    <p className='justify-content-between'>Sign up to receive timely and insightful threat advisories that keep you informed and prepared. Expert analyses from Sequretek Research Labs break down complex cybersecurity threats into actionable insights, helping you safeguard your organization against emerging risks.</p>
                                </div>
                                <div className={window.innerWidth > 767 ? 'col-md-8 col-sm-12 ' : 'col-12 pe-0'}>
                                    <Formik innerRef={formikRef} initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmit}>
                                        {({ setFieldValue, errors, values, touched, isSubmitting }) => (
                                            <Form className="users_form">
                                                <div className='row me-0 seq-breach-form'>
                                                    <h5><img src='/images/comment-icon.svg' alt='' /> &nbsp;Subscribe to Our Threat Advisory</h5>
                                                    <div className='col-md-6 mt-3'>
                                                        <div className='form-group mt-2'>
                                                            <Field
                                                                type="text"
                                                                name="fname"
                                                                placeholder="First Name*"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="fname" component="div" className="error-message" />
                                                        </div>
                                                    </div>
                                                    <div className={window.innerWidth > 767 ? 'col-md-6 mt-3' : 'col-md-6'}>
                                                        <div className='form-group mt-2'>
                                                            <Field
                                                                type="text"
                                                                name="lname"
                                                                placeholder="Last Name*"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="lname" component="div" className="error-message" />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className='form-group mt-2' >
                                                            <Field
                                                                type="text"
                                                                name="job"
                                                                placeholder="Job title"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="job" component="div" className="error-message" />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className='form-group mt-2' >
                                                            <Field
                                                                type="text"
                                                                name="organization"
                                                                placeholder="Company Name*"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="organization" component="div" className="error-message" />
                                                        </div>
                                                    </div>

                                                    <div className='col-md-12'>
                                                        <div className='form-group mt-2' >
                                                            <Field
                                                                type="text"
                                                                name="email"
                                                                placeholder="Business Email*"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="email" component="div" className="error-message" />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className='form-group mt-2' >
                                                            <Field
                                                                type="text"
                                                                name="phone"
                                                                placeholder="Phone Number"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="phone" component="div" className="error-message" />
                                                        </div>
                                                    </div>
                                                    <div className='col-md-12'>
                                                        <div className='form-group mt-2' >
                                                            <Field
                                                                type="text"
                                                                as='textarea'
                                                                rows={4}
                                                                name="message"
                                                                placeholder="Any Information that you would like to convey to the Sequretek team"
                                                                className='form-control'
                                                                autoComplete='off'
                                                            />
                                                            <ErrorMessage name="message" component="div" className="error-message" />
                                                        </div>
                                                    </div>
                                                    <div className='submit-btn'>
                                                        {loading ?
                                                            <button type='submit' style={{ backgroundColor: '#1BA431' }} ><img src='/images/tick-white.svg' alt='' /></button> :
                                                            <button type='submit' disabled={isSubmitting} >{isSubmitting ? <Spinner animation="border" variant="light" /> : 'Submit'}</button>
                                                        }
                                                    </div>

                                                    {window.innerWidth < 767 ? <p className='privacy-text'>Your privacy matters. By filling out this form, you consent to the collection, storage, and use of your PII as per our privacy policy. We will protect your data and not share it with third parties without your consent, except as required by law.</p> : null}

                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>

                            </div>
                        </div>
                        {window.innerWidth > 767 ? <p className='privacy-text'>By clicking submit, I consent to the processing of my contact information by Sequretek and its partners, including to Sequretek contacting me and sharing my contact information with its partners. I acknowledge that Sequretek will use and keep my contact information for as long as necessary for these purposes in accordance with its Privacy Notice</p> : null}
                    </div>
                </div>
            </div>


            <Modal
                show={isConfirm}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                // onHide={() => setIsConfirm(false)}
                dialogClassName={"confirm-modal"}
            >
                {
                    loading ?
                        null :
                        <div className='close-sticky'>
                            <img src='/images/close.svg' alt='' onClick={() => setIsConfirm(false)} />
                        </div>
                }
                <div className="p-4" >
                    <div>
                        <LoadCanvasTemplate reloadText="Reload" />
                    </div>
                    <div className='form-group mt-3'>
                        <input className='form-control' placeholder="Enter Captcha Value" id="user_captcha_input" name="user_captcha_input" type="text" />
                    </div>
                    <span style={{ color: 'red' }}>{captchaError}</span>
                    <div className="save-btn1">
                        <button disabled={loading} onClick={() => handleCaptchaSubmit()}>{loading ? <Spinner animation="border" variant="light" /> : 'Submit'}</button>&nbsp;&nbsp;
                    </div>
                </div>
            </Modal>
        </div >
    )
}
